/**
 * Shared inline styles for admin form labels/inputs. Previously copy-pasted
 * (with tiny, drifting variations) across AdminArtistForm, ImageUploadField,
 * and CustomShowHistoryField — a styling tweak to one no longer silently
 * misses the others.
 */

export const labelStyle = {
  display: 'block',
  fontSize: '0.82rem',
  fontWeight: '600',
  color: '#555',
  marginBottom: '0.3rem',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const inputStyle = {
  width: '100%',
  padding: '0.55rem 0.75rem',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '0.9rem',
  outline: 'none',
  boxSizing: 'border-box',
};
